document.addEventListener('DOMContentLoaded', function() {
  $('.reviewsBlock__contentWrapper').on('init', function (event, slick) {
    changeProgressBar(slick, 0);
  });

  $('.reviewsBlock__contentWrapper').slick({
    infinite: false,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    rows: 0,
    prevArrow: '<div class="reviewsBlock__prevArrow"><div class="reviewsBlock__prevArrowLineFirst"></div><div class="reviewsBlock__prevArrowLineSecond"></div></div>',
    nextArrow: '<div class="reviewsBlock__nextArrow"><div class="reviewsBlock__nextArrowLineFirst"></div><div class="reviewsBlock__nextArrowLineSecond"></div></div>',
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  });

  $('.reviewsBlock__contentWrapper').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    changeProgressBar(slick, nextSlide);
  });


  function changeProgressBar(slick, nextSlide) {
    let calc = ((nextSlide + 1) / (slick.slideCount - 1)) * 100;
    let progressBar = $('.reviewsBlock__progress');

    if(window.outerWidth <= 960) {
      calc = ((nextSlide + 1) / (slick.slideCount)) * 100;
    }

    progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
  }
});